import { GRM_FILTER_FIELDS } from "../utils/grmListingFilters";

// One GRM page set serves both streams; a stream swaps the workflow set, the category depth and the copy.
const TECH_COPY = {
  "GRM_LIST.TITLE": "TECH_LIST.TITLE",
  "GRM_LIST.BREADCRUMB": "TECH_LIST.BREADCRUMB",
  "GRM_LIST.CTA_REGISTER": "TECH_LIST.CTA_REGISTER",
  "GRM_LIST.TABLE_LABEL": "TECH_LIST.TABLE_LABEL",
  "GRM_LIST.EMPTY_CTA": "TECH_LIST.EMPTY_CTA",
  "GRM_LIST.EMPTY_FILTERED": "TECH_LIST.EMPTY_FILTERED",
  "GRM_LIST.ERROR": "TECH_LIST.ERROR",
  "GRM_LIST.COL_CATEGORY": "TECH_LIST.COL_CATEGORY",
  "GRM_LIST.COL_SUB_SUB_CATEGORY": "TECH_LIST.COL_SUB_CATEGORY",
  "GRM_LIST.LOADING": "TECH_LIST.LOADING",
  "GRM_LIST.TABS_LABEL": "TECH_LIST.TABS_LABEL",
  "GRM_LIST.FILTER_ARIA": "TECH_LIST.FILTER_ARIA",
  "GRM_RAISE.TITLE": "TECH_RAISE.TITLE",
  "GRM_RAISE.BREADCRUMB": "TECH_RAISE.BREADCRUMB",
  "GRM_RAISE.SECTION": "TECH_RAISE.SECTION",
  "GRM_RAISE.CATEGORY": "TECH_RAISE.CATEGORY",
  "GRM_RAISE.SUB_SUB_CATEGORY": "TECH_RAISE.SUB_CATEGORY",
  "GRM_RAISE.CATEGORY_PLACEHOLDER": "TECH_RAISE.CATEGORY_PLACEHOLDER",
  "GRM_RAISE.SUB_SUB_CATEGORY_PLACEHOLDER": "TECH_RAISE.SUB_CATEGORY_PLACEHOLDER",
  "GRM_RAISE.ERROR_CATEGORY": "TECH_RAISE.ERROR_CATEGORY",
  "GRM_RAISE.SUBMIT_ERROR": "TECH_RAISE.SUBMIT_ERROR",
  "GRM_RAISE.CREATE_PGR_ERROR": "TECH_RAISE.CREATE_PGR_ERROR",
  "GRM_RAISE.LOADING": "TECH_RAISE.LOADING",
  "GRM_RAISE.LOAD_ERROR": "TECH_RAISE.LOAD_ERROR",
  "GRM_RAISE.SUCCESS_TITLE": "TECH_RAISE.SUCCESS_TITLE",
  "GRM_RAISE.SUCCESS_BODY": "TECH_RAISE.SUCCESS_BODY",
  "GRM_RAISE.VIEW_TICKET": "TECH_RAISE.VIEW_TICKET",
  "GRM_TICKET.NOT_FOUND": "TECH_TICKET.NOT_FOUND",
  "GRM_TICKET.PAGE_TITLE": "TECH_TICKET.PAGE_TITLE",
  "GRM_TICKET.CATEGORY": "TECH_TICKET.CATEGORY",
  "GRM_TICKET.SUB_SUB_CATEGORY": "TECH_TICKET.SUB_CATEGORY",
  "GRM_TICKET.DOWNLOAD": "TECH_TICKET.DOWNLOAD",
  "GRM_TICKET.AADHAAR_NAME": "TECH_TICKET.NAME",
  "GRM_TICKET.LOADING": "TECH_TICKET.LOADING",
  "GRM_TICKET.ERROR": "TECH_TICKET.ERROR",
  "GRM_TICKET.UNASSIGNED": "TECH_TICKET.UNASSIGNED",
};

const TECH_FILTER_FIELDS = [
  { id: "category", kind: "singleSelect", labelKey: "TECH_LIST.FILTER_CATEGORY", optionsKey: "categoryOptions", clearable: true },
  {
    id: "subSubCategory",
    kind: "singleSelect",
    labelKey: "TECH_LIST.FILTER_SUB_CATEGORY",
    optionsKey: "leafOptions",
    dependsOn: "category",
    clearable: true,
  },
  { id: "dateRange", kind: "dateRange", labelKey: "GRM_LIST.FILTER_DATE", clearable: false },
];

/**
 * { id, workflows, levels (category-level ids shown, top → leaf), route, requiresDbt,
 *   allowsSelf (AGENT may raise for themselves as well as for a verified farmer), allowsReopen, allowsRating, filterFields,
 *   personalFields (grmTicketDetails PERSONAL_FIELDS keys shown on the ticket page),
 *   contactFields (same keys, shown read-only on the raise page), copy (GRM key → stream key) }
 */
export const GRM_STREAMS = Object.freeze({
  grievance: Object.freeze({
    id: "grievance",
    workflows: ["GRM1", "GRM2"],
    levels: ["category", "subCategory", "subSubCategory"],
    route: "help/grievances",
    requiresDbt: true,
    allowsSelf: false,
    allowsReopen: true,
    allowsRating: true,
    filterFields: GRM_FILTER_FIELDS,
    personalFields: ["dbtId", "aadhaar", "name", "fatherName", "dob", "gender", "mobile", "caste", "farmerType"],
    contactFields: [],
    copy: {},
  }),
  techSupport: Object.freeze({
    id: "techSupport",
    workflows: ["GRM9"],
    levels: ["category", "subSubCategory"],
    route: "help/tech-support",
    requiresDbt: false,
    allowsSelf: true,
    allowsReopen: false,
    allowsRating: true,
    filterFields: TECH_FILTER_FIELDS,
    personalFields: ["name", "mobile"],
    contactFields: ["name", "mobile"],
    copy: TECH_COPY,
  }),
});

export const isTwoLevelStream = (stream) => !stream.levels.includes("subCategory");
